import { format } from "date-fns";

import { resolveCheckout } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    const url = new URL(site.reserveUrl);
    url.searchParams.set("checkin", format(arrivalDate, "yyyy-MM-dd"));
    url.searchParams.set("checkout", format(checkout, "yyyy-MM-dd"));
    return url.toString();
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &checkin=YYYY-MM-DD.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &checkout=YYYY-MM-DD; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes:
            "Cloudbeds does not expose a durable per-bunk deep link; the user selects the named bunk on the property page.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Each site is one bunk; party size is not encoded.",
        },
      },
    };
  },
};
